import MailScopeRequest from 'src/adminPanel/entities/it/mail/MailTemplateScopeRequest';
import Mail from '../adminPanel/entities/it/mail/Mail';
import { CallApiResult, callMailApi } from '../api';

export const getMailTemplateAdmin = (): Promise<CallApiResult> => {
    return callMailApi('/mail/v3/mailKeys');
};

export const updateMailTemplateAdmin = (requestMail: Mail): Promise<CallApiResult> => {
    return callMailApi('/mail/v3/mailKeys/' + requestMail.id, {
        method: 'PUT',
        data: requestMail,
    });
};

export const addNewMailScopeToMailKey = (mailScopeRequest: MailScopeRequest): Promise<CallApiResult> => {
    return callMailApi('/mail/v3/mailScope/', { method: 'POST', data: mailScopeRequest });
};

export const deleteMailScopeFromMailKey = (mailScopeId: string): Promise<CallApiResult> => {
    return callMailApi('/mail/v3/mailScope/' + mailScopeId, { method: 'DELETE' });
};

export const getPreviewOfMailTemplate = (
    previewKey: string,
    previewRequest: Record<string, string>,
    region: string,
    language: string
) => {
    return callMailApi('/mail/v3/preview/' + previewKey, {
        method: 'POST',
        data: previewRequest,
        headers: { region, language },
    });
};

export const sendMailPreview = (
    mailKey: string,
    receivers: string[],
    scopes: Record<string, string>,
    region: string,
    language: string
) => {
    // Live-Runde 9: the admin test mail endpoint — the browser never calls the service-to-service /send
    return callMailApi('/mail/v3/admin/testmail/' + encodeURIComponent(mailKey), {
        method: 'POST',
        data: { receivers, scopes },
        headers: { region, language },
    });
};
